export interface PortalUsageGuideStep {
  id: string;
  title: string;
  what: string;
  why: string;
  howToUse: string[];
  path?: string;
}

export function portalUsageGuideStepIndexForPath(
  steps: readonly PortalUsageGuideStep[],
  pathname: string,
): number {
  const idx = steps.findIndex((step) => step.path === pathname);
  return idx >= 0 ? idx : 0;
}
